let imagePopup = ""
export let GENImagePopup = { imagePopup }
